export default "__VITE_ASSET__70397770__"